import { Component, DestroyRef, inject, ViewChild, AfterViewInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';
import { MatStepperModule } from '@angular/material/stepper';
import { SharedService } from '../../shared/services/shared.service';
import { Subscription } from 'rxjs';
import { Form4473, Form4473Transferee, Form4473Transferor, ReservedFirearm } from '../../shared/models/general';
import { DriverLicense } from '../../shared/models/drivers-license-parser';
import { boundBookEntriesToForm4473Firearms, getBoundBookEntriesByIds, getMinimumAgeForFirearm, getNicsResponseByNumber } from '../../shared/functions';
import { MatStepper } from '@angular/material/stepper';

@Component({
  selector: 'app-disposition-build',
  templateUrl: './disposition-build.component.html',
  styleUrl: './disposition-build.component.scss',
  standalone: true,
  imports: [FormsModule, NgClass, MatStepperModule],
})
export class DispositionBuildComponent {
  subscriptions = new Subscription();
  @ViewChild('stepper') stepper: MatStepper;
  private destroyRef = inject(DestroyRef);
  items1: string[] = [];
  reserved_firearms: ReservedFirearm[] = [];
  selected_drivers_license: DriverLicense = new DriverLicense();
  selected_transferee_4473: Form4473Transferee = new Form4473Transferee();
  seller_4473_created: Form4473Transferor = new Form4473Transferor();
  seller_4473_saved: boolean = false;
  minimum_are_requirement: number;
  constructor(public sharedService: SharedService) {
  }
  closeFirstStep(stepper: MatStepper) {
  stepper.selectedIndex = 1; // Moves to the second step (index is zero-based)
  // or simply: stepper.next();
}  
  ngAfterViewInit() {
  // reserved_4473_transferee_selected$
    this.subscriptions.add(
      this.sharedService.reserved_firearm_selected$
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((response) => {
          const bound_book_ids =
            this.sharedService.dispo_build_reserved_firearms.map(
              (firearm: ReservedFirearm) => firearm.bound_book_id
            );
          this.minimum_are_requirement = getMinimumAgeForFirearm(bound_book_ids, this.sharedService);
            setTimeout(() => {
            this.goToNextStep(1, 'reserved_firearm_selected$');
          }, 500);
        })
    );
    // reserved_4473_transferee_selected$
    this.subscriptions.add(
      this.sharedService.reserved_4473_transferee_selected$
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((response) => {
          setTimeout(() => {
            this.goToNextStep(2, 'reserved_4473_transferee_selected$')
          }, 500);
          
        })
    );
    // drivers_license_id_selected$
    this.subscriptions.add(
      this.sharedService.drivers_license_id_selected$
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((response) => {
          setTimeout(() => {
            this.goToNextStep(3, 'drivers_license_id_selected$')
          }, 500);
          
        })
    );
    // this.sharedService.manual_id_entered$
    this.subscriptions.add(
      this.sharedService.manual_id_entered$
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((response) => {
          setTimeout(() => {
            this.goToNextStep(3, 'manual_id_entered$')
          }, 500);
          
        })
    );
    // seller_form_4473_saved$
    this.subscriptions.add(
      this.sharedService.seller_form_4473_saved$
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((response) => {
            if (this.sharedService.dispo_build_seller_4473.nics_initial_response === '1') {
              this.seller_4473_saved = true;
              setTimeout(() => {
                this.goToNextStep(4, 'seller_form_4473_saved$')
              }, 500);
            } else if (this.sharedService.dispo_build_seller_4473.nics_initial_response === '2') {
              const denied_message = `${this.sharedService.dispo_build_selected_transferee_4473.name_first} + ' ' + 
                             ${this.sharedService.dispo_build_selected_transferee_4473.name_middle} + ' ' + 
                             ${this.sharedService.dispo_build_selected_transferee_4473.name_last} + ' was DENIED by NICS. This 4473 will now be recorded.'`
              this.sharedService.openMessageModal(denied_message);
              // save the 4473 in a 
            } else if (this.sharedService.dispo_build_seller_4473.nics_initial_response === '3') {
                const cancel_message = `NICS request was canceled`
                this.sharedService.openMessageModal(cancel_message);
            } else if (this.sharedService.dispo_build_seller_4473.nics_initial_response === '4') {
                const delayed_message = `NICS request was delayed. This disposition will be saved as PENDING, waiting for a final NICS response`
                this.sharedService.openMessageModal(delayed_message);
            }
        })
    );
  }
  async ngOnInit() {
    this.addDummyObjectToReservedFirearms();
  }
  openHome() {
    this.sharedService.changeRoute('home');
  }
  addDummyObjectToReservedFirearms() {
    const dummy = new ReservedFirearm();
    this.reserved_firearms.push(dummy);
  }
  goToNextStep(index: number, text: string) {
    this.stepper.selectedIndex = index;
  }
  translateNicsResponse(): string {
    const response = getNicsResponseByNumber(+this.sharedService.dispo_build_seller_4473.nics_initial_response)
    if (response) {
      return response
    } else {
      return 'NICS not transmitted'
    }   
  }
  async reviewAndSign4473() {
    console.warn(this.sharedService.company_info);
    let form4473:Form4473 = new Form4473();
    form4473.transaction_serial_number = '1';
    form4473.transferee = this.sharedService.dispo_build_selected_transferee_4473;
    form4473.transferor = this.sharedService.dispo_build_seller_4473;
    form4473.ffl = {
      ffl: this.sharedService.company_info.ffl,
      legal_name: this.sharedService.company_info.legal_name,
      company_name: this.sharedService.company_info.company_name,
      address: this.sharedService.company_info.address,
      address2: this.sharedService.company_info.address2,
      city: this.sharedService.company_info.city,
      state: this.sharedService.company_info.state,
      zip_code: this.sharedService.company_info.zip_code
    };
    let bound_book_ids: string[] = [];
    for (const firearm of this.sharedService.dispo_build_reserved_firearms) {
        bound_book_ids.push(firearm.bound_book_id);
    }
    const firearms = getBoundBookEntriesByIds(this.sharedService, bound_book_ids)
    form4473.firearms = boundBookEntriesToForm4473Firearms(firearms)
    try {
          await this.sharedService.generateAndDisplay4473(form4473);
        } catch (error) {
          console.error('Error:', error);
        }
  }

}
